import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UsePublishCampaignProps = Readonly<{
  campaignId: string | undefined
  onPublished: () => void
  onError: (error: Record<'code' | 'message' | 'title', string>) => void
}>

export type UsePublishCampaignReturn = Readonly<{
  isLoading: boolean
  publishCampaign: () => void
}>

const defaultError = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const usePublishCampaign = ({
  campaignId,
  onPublished,
  onError
}: UsePublishCampaignProps): UsePublishCampaignReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: publishCampaign }] = useMutation(
    workplaceGivingService.publishGivingCampaign,
    () => {
      onPublished()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    publishCampaign: () => {
      if (campaignId) {
        publishCampaign(campaignId)
      }
    }
  }
}
